import React, { type Ref } from 'react';

import { Input, type TypeInputProps } from '@thefarmersfront/kitchen';

import { formatNumber } from '~/utils';

import styles from './NumberUnitInput.module.scss';

const getFormattedFloatNumber = (value: string) => {
  const [integerPart, decimalPart] = value.split('.');

  const hasComma = value.includes('.');

  const formattedIntegerPart = formatNumber(Number(integerPart));
  return decimalPart || hasComma ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
};

const NumberUnitInput = ({
  className,
  onChange,
  onBlur,
  value,
  ref,
  ...props
}: Omit<TypeInputProps, 'type'> & { ref?: Ref<HTMLInputElement> }) => {
  const handleEventWithValidation = <
    T extends React.ChangeEvent<HTMLInputElement> | React.FocusEvent<HTMLInputElement>,
  >(
    event: T,
    callback?: (event: T) => void
  ) => {
    const regexNumber = /^[0-9.]+$/;

    const numberValue = event.target.value.replaceAll(',', '');

    const isEmpty = numberValue === '';
    const isNumber = regexNumber.test(numberValue) && Number.isNaN(Number(numberValue)) === false;

    if (isEmpty || isNumber) {
      const newEvent = {
        ...event,
        target: {
          ...event.target,
          id: event.target.id,
          value: numberValue,
        },
      };

      callback?.(newEvent);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => handleEventWithValidation(e, onChange);

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => handleEventWithValidation(e, onBlur);

  return (
    <Input
      ref={ref}
      {...props}
      className={`${styles['unit-input']} ${className}`}
      type="text"
      value={value === '' ? '' : getFormattedFloatNumber(String(value))}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default NumberUnitInput;
